import { guid } from 'globals/utils';
import { Message } from 'models';

import AppAPI from '../../../../api';
import * as chatAppActions from '../../app/ChatApp/actions';
import * as volumeControlActions from '../ChatConversationVolumeControlInput/actions';

const OPTIMISTIC_SEND_LOADING_DELAY = 300; // milliseconds

export const CHAT_MESSAGE_SEND_OPTIMISTICALLY = 'chat-message-send-optimistically';
export const CHAT_MESSAGE_SENT_SUCCESS = 'chat-message-sent-success';
export const CHAT_MESSAGE_SENT_FAILED = 'chat-message-sent-failed';
export const CHAT_MESSAGE_SENT_LOADING = 'chat-message-sent-loading';
export const CHAT_MESSAGE_SENT_RETRY = 'chat-message-sent-retry';

export const messageSendOptimistically = partialMessage => {
  return { type: CHAT_MESSAGE_SEND_OPTIMISTICALLY, partialMessage };
};

export const messageSentSuccess = (message, partial) => {
  return { message, partial, type: CHAT_MESSAGE_SENT_SUCCESS };
};

export const messageSentFailed = (response, partialMessage) => {
  return { response, partialMessage, type: CHAT_MESSAGE_SENT_FAILED };
};

export const messageSentLoading = partialMessage => {
  return { partialMessage, type: CHAT_MESSAGE_SENT_LOADING };
};

export const messageSentRetry = partialMessage => {
  return { partialMessage, type: CHAT_MESSAGE_SENT_RETRY };
};

export const handleSendSessionMessage = message => {
  return dispatch => {
    const requestData = {
      body: message.body,
      session: message.sessionId,
    };

    const loadingTimeout = setTimeout(() => {
      dispatch(messageSentLoading(message));
    }, OPTIMISTIC_SEND_LOADING_DELAY);

    return (messagePartial => {
      AppAPI.sendChatMessage(requestData)
        .then(m => {
          clearTimeout(loadingTimeout);
          dispatch(messageSentSuccess(m, messagePartial));
          dispatch(chatAppActions.handleMarkChatSessionSeen(message.sessionId));
          dispatch(chatAppActions.maybeDismissCampaigns());
          dispatch(chatAppActions.maybeUpdateSingleChat());
        })
        .catch(e => {
          clearTimeout(loadingTimeout);
          dispatch(messageSentFailed(e, messagePartial));
        });
    })(message);
  };
};

export const handleSendSessionMessageOptimistically = (sessionId, data) => {
  return dispatch => {
    const message = data;
    message.id = guid();
    message.type = 'customer';
    message.sessionId = sessionId;
    const newMessage = Message(message);

    AppAPI.setActiveSession(sessionId);

    dispatch(messageSendOptimistically(newMessage));
    dispatch(handleSendSessionMessage(newMessage));
  };
};

const ensureCustomerDescribeFlush = () => {
  if (!AppAPI.hasCustomerId()) {
    AppAPI.refreshTrackingToken();
  }
};

export const handleSendNewMessage = data => {
  return dispatch => {
    const messageBody = data.body || '';
    const sessionTitle = messageBody.substr(0, 256);
    return AppAPI.createSession(sessionTitle).then(session => {
      const sessionId = session.id;

      dispatch(chatAppActions.chatNewSession(session));
      dispatch(handleSendSessionMessageOptimistically(sessionId, data));
      dispatch(chatAppActions.maybeDismissCampaigns());
      dispatch(volumeControlActions.handleMaybeStart(sessionId, false));
      AppAPI.flushPendingDescribeNexts();

      ensureCustomerDescribeFlush();

      return session;
    });
  };
};

export const handleChatRetryMessageSend = message => {
  return dispatch => {
    dispatch(messageSentRetry(message));

    const DELAY_TO_CLEAR_FAILED_TO_INDICATE_RETRYING = 1000;
    setTimeout(() => {
      dispatch(handleSendSessionMessage(message));
    }, DELAY_TO_CLEAR_FAILED_TO_INDICATE_RETRYING);
  };
};
